module.exports = __webpack_public_path__ + "static/digital-periodic-maintenance-sm-48f680cfe10504e47c314a281e455a0d.jpg";